function Footer() {
  return (
    <footer className="bg-[#616247FF] text-[#DAA03DFF] text-center py-2 px-4 sm:px-4 lg:px-8 xl:px-16 font-light" style={{ position: 'relative', height: '60px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
      <p className="text-sm sm:text-base lg:text-lg xl:text-xl mb-1">
        © 2023 Copyright: Ron Yeh
      </p>
    </footer>
  );
}

export default Footer;
